// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__303ig","content":"styles_content__3zSEJ","checkbox":"styles_checkbox__16EFh","checkboxLabel":"styles_checkboxLabel__2_Lzr"};